import axiosIns from '@/plugins/axios'

export default {
  getKpis() {
    return axiosIns.get('/v2/monitor/kpis')
  },
}
